var $55e477eb56f9e069$exports = {};
$55e477eb56f9e069$exports = {
    "pending": `\u{43D}\u{435}\u{434}\u{43E}\u{432}\u{44A}\u{440}\u{448}\u{435}\u{43D}\u{43E}`
};


export {$55e477eb56f9e069$exports as default};
//# sourceMappingURL=bg-BG.mjs.map
